import { Component, OnDestroy, OnInit } from '@angular/core'
import { Meta, Title } from '@angular/platform-browser'
import { ActivatedRoute } from '@angular/router'
import { ContentService } from '../../services/content/content.service'
import { JsonLdService } from '../../services/json-ld/json-ld.service'
import { MANUALS_SCHEMA } from '../../schemas/manuals.schema'
import { MANUAL_ICE_MACHINE_SCHEMA } from '../../schemas/manual-ice-machine.schema'

const SCHEMAS_BY_CMS_SLUG: Record<string, object> = {
	downloads: MANUALS_SCHEMA,
	'manual-maquinas-de-gelo': MANUAL_ICE_MACHINE_SCHEMA,
}

@Component({
	selector: 'app-downloads',
	templateUrl: './downloads.component.html',
	styleUrls: ['./downloads.component.scss'],
})
export class DownloadsComponent implements OnInit, OnDestroy {
	constructor(
		private content: ContentService,
		private title: Title,
		private meta: Meta,
		private route: ActivatedRoute,
		private jsonLd: JsonLdService
	) {}

	dataDownload: any
	pageNotFound = false
	lang = 'pt'

	ngOnDestroy(): void {
		this.jsonLd.removeSchema()
	}

	ngOnInit(): void {
		this.lang = this.route.snapshot.params.lang
		const cmsSlug = this.route.snapshot.data.cmsSlug || 'downloads'
		const schema = SCHEMAS_BY_CMS_SLUG[cmsSlug]
		if (schema) {
			this.jsonLd.insertSchema(schema)
		}

		this.content.getPage(
			`pages/?type=cms.Downloads&fields=*&slug=${cmsSlug}&`,
			this.lang,
			{
				fnSuccess: (data: any) => {
					const page = data.items?.[0]

					if (!page) {
						this.pageNotFound = true
						console.warn(
							`Página de manuais não encontrada para o slug "${cmsSlug}" e locale "${this.lang}".`
						)
						return
					}

					const pageTitle =
						page.meta.seo_title ||
						page.title ||
						this.route.snapshot.data.title ||
						'Downloads'
					const pageDescription = page.meta.search_description || ''

					this.title.setTitle(pageTitle)
					this.meta.updateTag({
						name: 'description',
						content: pageDescription,
					})
					this.meta.updateTag(
						{
							property: 'og:description',
							content: pageDescription,
						},
						"property='og:description'"
					)
					this.meta.updateTag(
						{
							property: 'og:title',
							content: pageTitle,
						},
						"property='og:title'"
					)
					this.dataDownload = page
				},
				fnError: (err) => {
					this.pageNotFound = true
					console.warn(err)
				},
			}
		)
	}
}
